import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    background: {
      default: "#dedede",
    },
    primary: {
      main: "#5515E6",
    },
  },
});

export default theme;
